<template>

	<div>
		<div class="white">
			<div class="row">
				<div class="col-20">

					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li>
									<LangSwitch type="single" v-bind:downloadCallback="getMarketsCompleteHandler" v-bind:callback="langChanged"></LangSwitch>
								</li>
								<!-- <li><a href="#">Code</a></li> -->
							</ul>
						</nav>

					</div>

				</div>
			</div>
		</div>

		<div v-if="permissions.add" class="btns-top">
			<router-link v-if="mainSlug !== 'pages'" class="btn btn-add fa fa-plus transition-fadeinup transition-delay-01" :to="`${entityid}/add`"></router-link>
			<router-link v-else class="btn btn-add fa fa-plus transition-fadeinup transition-delay-01" :to="`pages/${entityid}/add`"></router-link>
		</div>

		<div class="row" v-if="this.totalCount === 0">
			<div class="col-20">

				<div class="addFirstItem transition-fadeinup">
					<p>No items found!<br><br></p>
					<router-link class="btn transition-fadeinup transition-delay-01" :to="`${entityid}/add`">
						<span class="fa fa-plus"></span> Add first item
					</router-link>
				</div>

			</div>
		</div>

		<template v-for="tree in structureGroupsTrees">
			<div class="row" :key="tree.group + 1">
				<div class="col-20">

					<h2>{{ tree.group }}</h2>

				</div>
			</div>

			<ul class="data-view transition-fadeinup" :key="tree.group + 2">
				<li class="headings">
					<span>{{ columns[0].translations.en.value }}</span>
					<div>
						<span>Published</span>
						<span v-if="mainSlug === 'pages'">Hide</span>
						<div class="btn-space" v-if="permissions.edit"></div>
						<div class="btn-space" v-if="permissions.delete"></div>
					</div>
				</li>
			</ul>

			<!-- Used for nestable lists -->
			<ul class="data-view pages-groups-view transition-fadeinup draggable-container main-draggable-container" :key="tree.group + 3" :data-group="tree.group">
				<ObjectOverviewItem v-for="instance in tree.tree"
					:key="instance.id"
					:data="instance"
					:instances="items"
					:columns="columns"
					:markets="markets"
					:linkedEntity="linkedEntity"
					:mainSlug="mainSlug"
					:permissions="permissions"
					:collapseToggleChangeHandlerCallback="collapseToggleChangeHandler"
					:stateToggleChangeHandlerCallback="stateToggleChangeHandler"
					:visibilityToggleChangeHandlerCallback="visibilityToggleChangeHandler"
					ref="instanceElement"
				></ObjectOverviewItem>
			</ul>
		</template>

		<div class="bubble bubble-delete-confirm">
			<a href="" class="btn red btn-bubble-delete" v-on:click="deleteRecord">Confirm</a>
			<a href="" class="btn black btn-bubble-cancel">Cancel</a>
		</div>
	</div>
</template>

<script>

import LangSwitch from '../../components/LangSwitch.vue'
import ObjectOverviewItem from '../content/ObjectOverviewItem.vue'
import sortable from '../../modules/sortable.js'
import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'

export default {
	name: 'ObjectOverview',
	props: ['content'],
	data () {
		return {
			entityid: null,
			items: null,
			activeLanguage: null,
			columns: null,
			totalCount: null,
			sortable: 'false',
			nestable: 'false',
			user: this.$store.state.user,
			permissions: {
				add: false,
				edit: false,
				delete: false
			},
			markets: null,
			linkedEntity: null,
			mainSlug: general.getMainSlug(),
			entity: null,
			instancesTree: null,
			sortProp: null,
			sortDirection: null,
			structureGroupsTrees: []
		}
	},
	components: {
		'LangSwitch': LangSwitch,
		'ObjectOverviewItem': ObjectOverviewItem
	},

	created () {
		this.entityid = 22

		this.body = document.querySelector('body')
		this.items = []
		this.activeLang = null
		this.fetchData()
	},

	methods: {
		direction (name) {
			if (name === this.sortProp) {
				return this.sortDirection
			} else {
				return ''
			}
		},

		langChanged (lang) {
			this.activeLanguage = lang
			if (this.nestable === 'true') this.filterOnLang()
		},

		fetchData () {
			this.body.classList.add('loading')
			var url = '/cms/api/entities?id=' + this.entityid
			xhrModule.get(url, this.getEntityCompleteHandler.bind(this))
		},

		getMarketsCompleteHandler (markets) {
			this.markets = markets.data
		},

		getEntityCompleteHandler (entity) {
			entity = entity.data
			this.entity = entity
			this.entityName = entity.name
			if (entity.settings.sortable) {
				this.sortable = entity.settings.sortable.value
				if (entity.settings.nestable) this.nestable = entity.settings.nestable.value
			}

			var permissions = general.checkPermissions(entity.privileges, this.user.roles)
			this.permissions = permissions

			// now we can define the columns that we want to show
			var properties = entity.properties
			var sortable = []
			for (var prop in properties) {
				if (!properties[prop].translations) continue
				if (!properties[prop].settings) continue
				if (properties[prop].settings.orderinoverview.value === '0') continue
				sortable.push(properties[prop])
			}

			sortable.sort(function (a, b) {
				return a.settings.orderinoverview.value - b.settings.orderinoverview.value
			})

			// when we are displaying the pages we will have to remove and edit a few fields in order to get the correct layout
			for (var i = sortable.length - 1; i >= 0; i--) {
				if (sortable[i].name !== 'title') {
					sortable.splice(i, 1)
				}
			}

			this.columns = sortable

			this.columnNames = []
			for (var key in this.columns) {
				this.columnNames.push(this.columns[key].name)
			}

			// now fetch all instances for this entity
			this.fetchInstances()
		},

		fetchInstances () {
			var url = '/cms/api/instances/ofEntity?entity=' + this.entityid
			xhrModule.get(url, this.getInstancesCompleteHandler.bind(this))
		},

		getInstancesCompleteHandler (instances) {
			var tempInstances = instances.data
			this.linkedEntity = instances.linked

			this.interpretInstances(tempInstances)
		},

		interpretInstances (tempInstances) {
			this.items = tempInstances
			this.filterOnLang()
		},

		filterOnLang () {
			// filter out all languages that we don't need
			var filteredInstances = []
			for (var i = this.items.length - 1; i >= 0; i--) {
				if (this.items[i].market === this.activeLanguage.id) {
					// edit the title in case there is a referenced item
					if (this.items[i].properties.references !== '') {
						this.items[i].properties.title = this.items[i].properties.references + ' **'
					}

					filteredInstances.push(this.items[i])
				}

				if (i === 0) {
					this.totalCount = filteredInstances.length

					// sort on offset_left
					filteredInstances.sort(function (a, b) {
						return a.properties.offset_left - b.properties.offset_left
					})

					// split everything up into structure groups
					let structureGroups = {}
					for (var s = 0; s < filteredInstances.length; s++) {
						var groupName = filteredInstances[s].properties.structure
						if (!structureGroups[groupName]) structureGroups[groupName] = []
						structureGroups[groupName].push(filteredInstances[s])

						if (s === filteredInstances.length - 1) {
							// create landingspages group if this does not exist yet
							if (!structureGroups['Landingspages']) structureGroups['Landingspages'] = []

							// create an instance tree for each group
							let groupsAmount = Object.keys(structureGroups).length
							let int = 0
							this.structureGroupsTrees = []
							for (let group in structureGroups) {
								int++
								let tree = this.createInstancesTree(structureGroups[group])
								let obj = {
									'group': group,
									'tree': tree
								}
								this.structureGroupsTrees.push(obj)
								if (int === groupsAmount) {
									// sort by group and put "main" at the start and "landingspages" at the bottom
									this.structureGroupsTrees.sort(function (a, b) {
										return a.group - b.group
									})

									// find index of 'main' and put it at the top
									var mainIndex = this.structureGroupsTrees.findIndex(el => el.group.toLowerCase() === 'main')
									this.structureGroupsTrees = general.arrayMove(this.structureGroupsTrees, mainIndex, 0)

									// find index of landingspages and put it at the back
									var landingspagesIndex = this.structureGroupsTrees.findIndex(el => el.group.toLowerCase() === 'landingspages')
									this.structureGroupsTrees = general.arrayMove(this.structureGroupsTrees, landingspagesIndex, this.structureGroupsTrees.length - 1)

									this.filteringDone()
								}
							}
						}
					}
				}
			}
		},

		filteringDone () {
			// this.totalCount = this.instancesTree.length
			this.body.classList.remove('loading')

			setTimeout(function () {
				this.checkSortable()
			}.bind(this), 100)
		},

		createInstancesTree (filteredInstances) {
			// create tree array we will use to render nested items
			var instancesTree = []

			// keep track of depth
			var depth = []

			// calculate the highest offset right and offset it with 1
			var totalRight = (filteredInstances.length * 2) + 1
			// add main depth
			depth.push({
				obj: instancesTree,
				left: 1,
				right: totalRight
			})

			for (var i = 0; i < filteredInstances.length; i++) {
				// preprare object for fieldstree
				var obj = {
					'id': filteredInstances[i].id,
					'children': []
				}

				var left = 1
				var right = 2

				var leftProp = filteredInstances[i].properties.offset_left
				var rightProp = filteredInstances[i].properties.offset_right

				if (leftProp) left = parseInt(filteredInstances[i].properties.offset_left)
				if (rightProp) right = parseInt(filteredInstances[i].properties.offset_right)

				// Find the correct depth of this item
				var depthFound = false
				var amountOfDepthsToDelete = 0
				for (var d = depth.length - 1; d >= 0; d--) {
					if (left > depth[d].left && right < depth[d].right) {
						depthFound = true
						var depthLength = depth.length
						amountOfDepthsToDelete = depthLength - (d + 1)
						if (amountOfDepthsToDelete > 0) depth.splice(d + 1, amountOfDepthsToDelete)
						break
					}

					if (d === 0 && !depthFound) {
						// go up to the main depth because the item should be in the main list
						amountOfDepthsToDelete = depth.length - 1
						depth.splice(1, amountOfDepthsToDelete)
					}
				}

				var lastDepth = depth[depth.length - 1]
				if (lastDepth.obj.children) {
					lastDepth.obj.children.push(obj)
				} else {
					lastDepth.obj.push(obj)
				}

				var difference = right - left
				if (difference !== 1) {
					// create new depth because this item has childs
					depth.push({
						id: filteredInstances[i].id,
						left: left,
						right: right,
						obj: obj
					})
				}

				if (i === filteredInstances.length - 1) {
					return instancesTree
				}
			}
		},

		checkSortable () {
			if (this.sortable === 'true') {
				if (this.sortableModule) return
				this.sortableModule = sortable({
					container: null,
					entityID: this.entityid,
					callback: this.sortCompleted.bind(this),
					nestable: this.nestable,
					collapsible: true,
					saveStructureCallback: this.saveStructureCallback.bind(this)
				})
				this.sortableModule.init()
			}
		},

		saveStructureCallback (item) {
			this.body.classList.add('loading')
			this.newStructureGroup = item.closest('ul.pages-groups-view').getAttribute('data-group')
			const uuid = item.getAttribute('data-uuid')

			// get instance(s) data
			var url = '/cms/api/instances?uuid2=' + uuid
			xhrModule.get(url, this.getInstanceDataCompleteHandler.bind(this))
		},

		getInstanceDataCompleteHandler (data) {
			const instances = data.data
			let mainObj = {
				entity: this.entityid,
				uuid: data.data[Object.keys(data.data)[0]].uuid,
				instance: []
			}

			for (let inst in instances) {
				let obj = {
					id: instances[inst].id,
					market: instances[inst].market,
					state: instances[inst].state,
					properties: [{
						id: instances[inst].data.structure.id,
						property: 104, // will never change
						value: this.newStructureGroup
					}]
				}

				mainObj.instance.push(obj)
			}

			let json = JSON.stringify(mainObj)
			let url = '/cms/api/instances/save'
			xhrModule.post(url, json, this.deletedInstanceCompleteHandler.bind(this))
		},

		sortCompleted () {
			this.updatedInstanceCompleteHandler()
		},

		deleteRecord (e) {
			e.preventDefault()

			var target = e.currentTarget
			var uuid = target.getAttribute('data-id')

			var obj = {
				'entity': null,
				'uuid': null,
				'instance': []
			}

			// find all instances with this UUID and set their state to 5
			for (var i = this.items.length - 1; i >= 0; i--) {
				if (this.items[i].uuid === uuid) {
					if (!obj.entity) {
						obj.entity = this.entityid
						obj.uuid = this.items[i].uuid
					}

					obj.instance.push({
						'id': this.items[i].id,
						'market': this.items[i].market,
						'state': 5
					})
				}

				if (i === 0) {
					var json = JSON.stringify(obj)

					var url = '/cms/api/instances/save'
					xhrModule.post(url, json, this.deletedInstanceCompleteHandler.bind(this))
				}
			}
		},

		deletedInstanceCompleteHandler () {
			// all changes have been posted
			this.fetchData()
			this.updatedInstanceCompleteHandler()
		},

		collapseToggleChangeHandler (e) {
			var target = e.currentTarget
			target.classList.toggle('open')

			var parent = target.parentNode.parentNode.parentNode
			parent.classList.toggle('open')
		},

		stateToggleChangeHandler (e) {
			// debounce this event in case the user toggles through the options a few time
			// we don't want to post the new value multiple times
			var target = e.currentTarget
			var input = target.querySelector('input')

			clearTimeout(this.debounceStateToggle)

			this.debounceStateToggle = setTimeout(function () {
				var value = input.value
				var instanceID = target.getAttribute('data-id')

				var obj = {
					'entity': null,
					'uuid': null,
					'instance': []
				}

				// find all instances with this UUID and set their state to 5
				for (var i = this.items.length - 1; i >= 0; i--) {
					var parsedID = parseInt(instanceID)
					if (this.items[i].id === parsedID) {
						if (!obj.entity) {
							obj.entity = this.entityid
							obj.uuid = this.items[i].uuid
						}

						obj.instance.push({
							'id': this.items[i].id,
							'market': this.items[i].market,
							'state': value
						})

						var json = JSON.stringify(obj)

						var url = '/cms/api/instances/save'
						xhrModule.post(url, json, this.updatedInstanceCompleteHandler.bind(this))

						break
					}
				}
			}.bind(this), 300)
		},

		destroySortable: function () {
			if (this.sortableModule) {
				this.sortableModule.destroy()
				this.sortableModule = null
			}
		},

		visibilityToggleChangeHandler (e) {
			var id = parseInt(e.currentTarget.getAttribute('data-id'))

			// find the instance with this ID
			for (var i = this.items.length - 1; i >= 0; i--) {
				var parsedID = parseInt(id)

				if (this.items[i].id === parsedID) {
					var currentState = this.items[i].properties['hide-from-navigation']
					var bool = 'true'
					if (currentState === 'true') bool = 'false'

					// change state
					this.items[i].properties['hide-from-navigation'] = bool

					// find ID for hide from navigation prop
					var propertyID = this.entity.properties['hide-from-navigation'].id

					var obj = {
						instance: this.items[i].uuid,
						market: this.items[i].market,
						property: propertyID,
						value: bool
					}

					var json = JSON.stringify(obj)
					var url = '/cms/api/instances/update'
					xhrModule.post(url, json, this.updatedInstanceCompleteHandler.bind(this))
				}
			}
		},

		updatedInstanceCompleteHandler (data) {
			general.saveAnimation()
		}
	},

	watch: {
		$route (to) {
			this.destroySortable()
			this.entityid = to.params.entityid
			this.sortable = 'false'
			this.nestable = 'false'
			this.items = []
			this.columns = null
			this.totalCount = null
			this.permissions = {
				'add': false,
				'edit': false,
				'delete': false
			}
			this.markets = null
			this.linkedEntity = null
			this.mainSlug = general.getMainSlug()
			this.entity = null
			this.instancesTree = null
			this.structureGroupsTrees = []
			this.fetchData()
		}
	}
}
</script>
